import { Component, computed, input, output } from '@angular/core';

@Component({
    selector: 'app-revision-field',
    templateUrl: './revision-field.component.html',
    styleUrls: ['./revision-field.component.scss'],
    standalone: false
})
export class RevisionFieldComponent {
  /** Current field value to display. */
  value = input<string | null | undefined>('');

  /** Previous field value for compare mode. Undefined when not yet fetched. */
  previousValue = input<string | null | undefined>(undefined);

  /** Whether to show the edit icon. Should be false in compare mode. */
  isEditable = input<boolean>(false);

  /** Whether compare mode is active. */
  isCompareMode = input<boolean>(false);

  /** Emitted when the edit icon is clicked. */
  editClicked = output<void>();

  /** Whether the field value has changed compared to the previous value. */
  isChanged = computed<boolean>(() => {
    if (!this.isCompareMode()) { return false; }
    const prev = this.previousValue();
    // If previous data is not available, we cannot determine a change
    if (prev === undefined) { return false; }
    return this.normalize(this.value()) !== this.normalize(prev);
  });

  /** Display-safe current value. */
  displayValue = computed<string>(() => this.normalize(this.value()));

  /** Display-safe previous value. */
  displayPreviousValue = computed<string>(() => this.normalize(this.previousValue()));

  private normalize(val: string | null | undefined): string {
    return (val ?? '').trim();
  }
}
